import { addDoc, doc, getDocs, query, updateDoc } from "firebase/firestore";
import { clarifaiSettingsRef, db } from "../../../../firebase";

export const updateClarifai = async (id, docData) => {
  const docRef = doc(db, "clarifaiSettings", id);
  return await updateDoc(docRef, docData);
};

export const addClarifai = async (data) => {
  return await addDoc(clarifaiSettingsRef, data);
};

export const getClarifaiData = async () => {
  try {
    let temp = {};
    const response = await getDocs(clarifaiSettingsRef);
    response.forEach((element) => {
      temp = { ...element.data(), id: element.id };
    });

    return temp;
  } catch (error) {
    console.log("Error fetching data from Firestore:", error.message);
    return {};
  }
};
